module.exports = __webpack_public_path__ + "static/media/logoQualitas.635331f7.png";